import * as ng from 'angular';

ng.module('e360')
   .factory('instanceServiceFactory', instanceServiceFactory);

instanceServiceFactory.$inject = ['$injector'];

/**
 * The purpose of this is to provide a way for defining classes that still use
 * dependency injection via the constructor function, but are NOT singletons
 * (i.e. stateful service classes).
 *
 * Use the standard `$inject` annotation and include any extra constructor
 * arguments in the array. The factory function returned by calling this
 * factory will accept the extra arguments in map of name value pairs.
 * 
 * Admittedly the naming is not very expressive.
 */
export function instanceServiceFactory($injector:ng.auto.IInjectorService) {
   return function instanceService(TService) {
      return function<T>(argsMap:{}):T {
         return $injector.instantiate<T>(TService, argsMap);
      }
   }
}
